import {ref, reactive} from "@vue/composition-api";
import AppModule from "../store/modules/app";
import errorDialog from "@/views/ErrorDialog/errorDialog"

// NOTE: saveTemporary is passed in as a ref,
// Since autosave is set when in TaskView.vue -> handleLoadTaskResponse. Then a raw value would end up here before that value is set
// Not the best
export default function FileUpload(related_type, related_object, form_data, isWsUpdate, file_uploaded = null, file_deleted = null, multipleFilesAllowed = true, saveTemporary = false) {
    const {uploadFile, deleteFile} = AppModule();
    const dnd_over = ref(false);

    let upload_state = reactive({
        groups: [],
        total_files: 0,
        uploaded_files: 0,
        running: false,
        group_idx: 0,
        file_idx: 0
    });

    const upload_dragover = function (e) {
        e.preventDefault()
        if (dnd_over.value || e.dataTransfer.items[0].kind !== "file") return;
        dnd_over.value = true;

        return false;
    };
    const upload_dragleave = function () {
        if (!dnd_over.value) return;
        dnd_over.value = false;
    };
    const upload_drop = function (e) {
        upload_dragleave();

        let dt = e.dataTransfer;
        if (!dt) return;

        let files = dt.files;
        if (files.length === 0) return;
        if (!multipleFilesAllowed && files.length > 1) {
            files = [files[0]]
        }

        add_files_to_upload(files, true);
    };
    const upload_change = function (e) {
        add_files_to_upload([...e.target.files]);
        e.target.value = null;
    };

    const add_files_to_upload = function (files, for_comment = false) {
        if (!files.length) {
            return
        }
        form_data.value.files_error = null;

        for (let i = 0; i < files.length; i++) {
            form_data.value.files.push({
                id: 0,
                file_name: files[i].name,
                size: files[i].size,
                uploading: true,
                progress: 0,
                temp_id: null,
                temp_name: null,
                for_comment: for_comment,
                clientId: crypto.randomUUID()
            });
        }

        upload_state.groups.push(files);
        upload_state.total_files += files.length;

        if (!upload_state.running) {
            upload_next();
        }
    };
    const upload_next = function () {
        upload_state.running = true;

        let params = {
            related_type: related_type,
            file: upload_state.groups[upload_state.group_idx][upload_state.file_idx]
        };

        console.log("upload_next", params)

        switch (related_type) {
            case "task":
                params.task_id = related_object.value.id
                params.task_virtual_id = related_object.value.virtual_id
                params.save_temporary = saveTemporary && saveTemporary.value ? saveTemporary.value : false
                break;
            case "email_automation_template":
                params.template_id = related_object.value.id
                params.company_id = related_object.value.company_id
                break;
            case "email_task":
                params.task_id = related_object.value.id
                break;
            case "invoice_seller_logo":
            case "signature_logo":
            case "portal_logo":
            case "portal_icon":
                params.feature_id = related_object.value.feature_id
                params.account_id = related_object.value.account_id
                break;
            case "import_session":
                params.import_session_id = related_object.value.id
                break;
            case "client_workflow":
                params.import_session_id = related_object.value.id
                params.account_id = related_object.value.account_id
                params.related_type = related_object.value.related_type
                break;
            case "project_workflow":
                params.import_session_id = related_object.value.id
                params.account_id = related_object.value.account_id
                params.related_type = related_object.value.related_type
                break;
            default:
                console.error("Invalid upload type:", related_type);
                return;
        }

        uploadFile(params)
            .then(function (resp) {
                upload_state.uploaded_files++;
                mark_file_uploaded(resp, upload_state.group_idx, upload_state.file_idx);

                upload_state.file_idx++;
                if (upload_state.file_idx >= upload_state.groups[upload_state.group_idx].length) {
                    upload_state.group_idx++;
                    upload_state.file_idx = 0;
                    if (upload_state.group_idx >= upload_state.groups.length) {
                        upload_state.running = false;
                        return;
                    }
                }
                upload_next();
            })
            .catch(function (ex) {
                if (upload_state.groups[upload_state.group_idx]) {
                    upload_state.groups.splice(upload_state.group_idx, 1)
                }
                upload_state.total_files -= 1;

                upload_state.running = false;
                errorDialog.showError(ex);
                setTimeout(cancel_uploads, 2 * 1000);
            });
    };
    const mark_file_uploaded = function (resp, group_idx, file_idx) {
        if (isWsUpdate.value && file_uploaded == null) return;

        let f_name = upload_state.groups[group_idx][file_idx].name;
        for (let i = 0; i < form_data.value.files.length; i++) {
            let file = form_data.value.files[i];
            if (file.uploading && file.file_name === f_name) {
                if (!isWsUpdate.value || (saveTemporary && saveTemporary.value)) {
                    file.uploading = false;
                    file.progress = 100;
                    file.temp_id = resp.temp_id;
                    file.temp_name = resp.temp_name;
                }
                if (file_uploaded != null) {
                    file_uploaded(resp, file);
                }
                break;
            }
        }
    };
    const cancel_uploads = function () {
        upload_state.group_idx = upload_state.groups.length ? upload_state.groups.length - 1 : 0;
        upload_state.file_idx = upload_state.groups[upload_state.group_idx] ? upload_state.groups[upload_state.group_idx].length - 1 : 0;

        for (let i = form_data.value.files.length - 1; i >= 0; i--) {
            if (form_data.value.files[i].uploading) {
                form_data.value.files.splice(i, 1);
            }
        }
    };

    const delete_file = async function (f) {
        try {
            await deleteFile(form_data, f, related_object, related_type, file_deleted)
        } catch (ex) {
            errorDialog.showError(ex)
        }
    };

    return {
        dnd_over,
        upload_state,
        upload_dragover,
        upload_dragleave,
        upload_drop,
        upload_change,
        add_files_to_upload,
        delete_file
    };
}
